module.exports = __webpack_public_path__ + "static/media/hall-PC.041219ba.svg";